import CheckIcon from '@adv-mt/mt-svg-icons/lib/Check'

export const SELLER_DESCRIPTION_TEST_ID = 'mt-PanelAdDetails-description'
export const BASE_CLASS = 'mt-PanelAdDetails'

export const CHECK_ICON = {
  color: 'success',
  size: 'medium',
  type: CheckIcon
}
